import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Stack, Avatar, InputAdornment } from '@mui/material';
import { today } from '../../lib/api';
import { platformIconData } from '../../lib/social';
import Button from '../../components/Button';

const PLATFORM_OPTIONS = ['Instagram', 'TikTok', 'Douyin', 'Xiaohongshu'];

function PlatformOption({ platform }) {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Avatar src={platformIconData(platform)} variant="rounded" sx={{ width: 22, height: 22 }} />
      <span>{platform}</span>
    </Stack>
  );
}

function AddSocialModal({ onClose, onSubmit }) {
  const [platform, setPlatform] = useState('Instagram');
  const [handle, setHandle] = useState('');

  function submit() {
    if (!handle.trim()) return;
    onSubmit({
      platform,
      handle: handle.trim(),
      followers: 0,
      ownership: 'Self-reported',
      dataSource: 'Creator supplied',
      lastChecked: today,
      stats: { genderBreakdown: [], ageBreakdown: [], locationBreakdown: [] },
      metricsVisibility: { gender: true, ageRange: true, location: true },
    });
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add social profile</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            select
            fullWidth
            label="Platform"
            value={platform}
            onChange={(event) => setPlatform(event.target.value)}
            slotProps={{ select: { renderValue: (value) => <PlatformOption platform={value} /> } }}
          >
            {PLATFORM_OPTIONS.map((item) => (
              <MenuItem key={item} value={item}>
                <PlatformOption platform={item} />
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            label="Handle / Username"
            placeholder="yourhandle"
            value={handle}
            onChange={(event) => setHandle(event.target.value)}
            slotProps={{ input: { startAdornment: <InputAdornment position="start">@</InputAdornment> } }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={submit} disabled={!handle.trim()}>
          Add profile
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddSocialModal;
